import escape from "lodash/escape";
import isArray from "lodash/isArray";
import isFunction from "lodash/isFunction";

import { getLocalizedName } from "../roles";
import { t } from "../helpers/localization";

const ROLE_PLACEHOLDERS = {
  commander: '[commander]',
  executive_officer: '[exec_officer]',
  recruitment_officer: '[recr_officer]',
  commissioned_officer: '[comm_officer]',
  officer: '[officer]',
  private: '[private]'
};

export const formatRoleIcon = (roleName: string) => ROLE_PLACEHOLDERS[roleName];

export const formatClan = (clan: any) => {
  const name = escape(clan.name);
  const tag = escape(clan.tag);
  return `<span class="bold_default"><font color="${clan.color}">[${tag}]</font>&nbsp;${name}</span>`;
};

export const formatBold = (text: string) => `<span class="bold_default">${text}</span>`;

export const formatRole = (roleName: string) => formatBold(getLocalizedName(roleName));

export const formatRoleWithIcon = (roleName: string) => {
  const roleIcon = formatRoleIcon(roleName);
  const role = formatRole(roleName);
  return `${roleIcon}&nbsp;${role}`;
};

export const formatPlayer = (name: string, roleName?: string) => {
  const player = formatBold(name);
  if (roleName) {
    const roleIcon = formatRoleIcon(roleName);
    return `${roleIcon}&nbsp;${player}`;
  }
  return player;
};

export const wrapInP = (...args: any) => args.join('&#13;');

export const getMessageOfMembersNotInClanNotification = (missingMembersNames: any, clan: any) => t('%(players)s не в клане %(clan)s', {
  players: missingMembersNames.map((name: string) => formatPlayer(name)).join(', '),
  clan: formatClan(clan)
});

export const getMessageOfYouAreNotInClanNotification = (clan: any) => t('Вы не состоите в клане %(clan)s', {
  clan: formatClan(clan)
});

export const getMessageOfMemberNotInClanNotification = (memberName: string, clan: any) => t('%(name)s не состоит в клане %(clan)s', {
  name: formatPlayer(memberName),
  clan: formatClan(clan)
});

export const getMessage = (errors: any, reason: any, ...extra: any) => {
  const callbackOrMessage = errors[reason] || errors.default;
  const message = isFunction(callbackOrMessage) ? callbackOrMessage(...extra) : callbackOrMessage;
  return isArray(message) ? wrapInP(...message) : message;
};